import React from 'react';

const SvgDashboardAnomalie = ({ svgRef, title, ...props }) => (
  <svg id="dashboardAnomalie_svg__Capa_1" x={0} y={0} viewBox="0 0 41.4 41.4" xmlSpace="preserve" ref={svgRef} {...props} width="1em" height="1em">
    <title>{title}</title>
    <style>{'.dashboardAnomalie_svg__st0{fill:none;stroke:currentColor;stroke-linejoin:bevel;stroke-miterlimit:10}'}</style>
    <path
      className="dashboardAnomalie_svg__st0"
      d="M37.6 16.8c-.2-2.1-5.4 0-5.4 0l-.3 2.9c-.1-.1-.2-.1-.4-.2l-1.3-6.1c-.5-2.9-2.6-5.1-5.6-5h-7.8c0 .3-.1.7-.2 1h8.5c1.8 0 3.4 1.2 3.8 3.2l1.4 6.1H13.7v5.9h10.2V26H13.7v.4h10.1v1.2H13.7v5h10.9v3.1c0 1.2 1.5 2.3 3.3 2.3s3.3-1 3.3-2.3v-3.5c1.6-.6 2.6-2 2.6-3.6V23c0-1.2-.7-2.4-1.7-3.1l5.5-.3s.2-.7 0-2.8zm-5.3 11.1h-6V25h6v2.9z"
    />
    <path
      d="M16.6 8.6c0-2.5-1.3-4.6-3.2-5.7v5.3L10.2 10 7 8.1V2.8C5.1 4 3.8 6.1 3.8 8.6c0 2.6 1.4 4.8 3.5 5.9h0v21.8c0 .9.3 1.6.9 2.2.5.6 1.3.9 2.1.9 1.7 0 3-1.4 3-3.1V14.4c2-1.2 3.3-3.4 3.3-5.8zm-5.6 29c-.5.5-1.2.5-1.6 0-.4-.5-.4-1.2 0-1.7.5-.5 1.2-.5 1.6 0 .4.5.4 1.3 0 1.7z"
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
    />
    <path className="dashboardAnomalie_svg__st0" d="M29.3 11.9c1.1 2.2.2 3.1.2 3.1l.7 2.9V14l.6 3.5.4 2" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgDashboardAnomalie svgRef={ref} {...props} />);
export default ForwardRef;
